import React from 'react';
import Reveal from 'react-awesome-reveal';

// Import Custom Component
import OwlCarousel from '../../features/owl-carousel';

// Import Settings
import {HomeSlider} from '../../../utils/data/slider';

// Import Keyframes
import {fadeInUpShorter} from '../../../utils/data/keyframes'
import {hideQuickView} from "../../../store/modal/actions";
import {connect} from "react-redux";
import {removeXSSAttacks} from "../../../utils";
import useTranslation from "../../../utils/hooks/useTranslation";

// Plain-text alt for a slide, taken from its (HTML) title and subtitle.
function getSlideAlt(slide, fallback) {
    const text = [slide.title, slide.sub_title]
        .filter((value) => value && value !== ".")
        .map((html) => new DOMParser().parseFromString(html, "text/html").body.textContent)
        .join(" - ")
        .replace(/\s+/g, " ")
        .trim();

    return text || fallback;
}

function HomeSection({slider}) {
    const { t } = useTranslation();
    const {data} = slider;

    const getSliderVariation = (slide, variation, index) => {
        switch (variation) {
            case 1:
                return <SliderContentVariationOne slide={slide} index={index} key={slide.id} />
            case 2:
                return <SliderContentVariationTwo slide={slide} index={index} key={slide.id} />
            }
        }

    const Slider = ({slide, variation, index}) => {
        return getSliderVariation(slide, variation, index)
    }

    const SliderContentVariationOne = ({slide, index}) => {
        return (
            <div className="home-slide home-slide1 banner">
                <figure>
                    <img
                        alt={getSlideAlt(slide, t("seo.home_heading"))}
                        src={process.env.REACT_APP_PUBLIC_ASSET_URI + slide.url}
                        width="100%"
                        loading={index === 0 ? 'eager' : 'lazy'}
                        fetchpriority={index === 0 ? 'high' : 'auto'}
                        decoding={index === 0 ? 'sync' : 'async'}
                    />
                </figure>
                <div className="container d-flex align-items-center">
                    <div className="banner-layer">
                        <Reveal keyframes={ fadeInUpShorter } delay={ 100 } duration={ 1000 }>
                            <>
                                {slide.sub_title && slide.sub_title !== "." && <h4 className="m-b-1" aria-level="2" dangerouslySetInnerHTML={removeXSSAttacks(slide.sub_title)} />}
                                {slide.title && slide.title !== "." && <h3 className="m-b-3" dangerouslySetInnerHTML={removeXSSAttacks(slide.title)} />}
                            </>
                        </Reveal>
                    </div>
                </div>
            </div>
        )
    }

    const SliderContentVariationTwo = ({slide, index}) => {
        return (
            <div className="home-slide home-slide2 banner banner-md-vw">
                <figure>
                    <img
                        alt={getSlideAlt(slide, t("seo.home_heading"))}
                        src={process.env.REACT_APP_PUBLIC_ASSET_URI + slide.url}
                        width="100%"
                        loading={index === 0 ? 'eager' : 'lazy'}
                        fetchpriority={index === 0 ? 'high' : 'auto'}
                        decoding={index === 0 ? 'sync' : 'async'}
                    />
                </figure>
                <div className="container d-flex align-items-center">
                    <div className="banner-layer d-flex justify-content-center">
                        <Reveal keyframes={ fadeInUpShorter } delay={ 100 } duration={ 1000 }>
                            <div className="mx-auto">
                                {slide.sub_title && slide.sub_title !== "." && <h4 className="m-b-1" aria-level="2" dangerouslySetInnerHTML={removeXSSAttacks(slide.sub_title)} />}
                                {slide.title && slide.title !== "." && <h3 className="m-b-2" dangerouslySetInnerHTML={removeXSSAttacks(slide.title)} />}
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        )
    }

    if (!data?.length) {
        // Keep the slider's height reserved until the slides arrive so the page below doesn't jump
        return <div className="home-slider home-slider-placeholder mb-2" aria-hidden="true"/>;
    }

    return (
        <OwlCarousel adClass="home-slider owl-theme slide-animate show-nav-hover nav-big mb-2 text-uppercase" options={HomeSlider} >
            {data?.map((slide, index) => <Slider slide={slide} variation={index % 2 === 0 ? 1 : 2 } index={index} key={slide.id}/>)}
        </OwlCarousel>
    );
}

const mapStateToProps = ( state ) => {
    return {
        slider: state.slider,
    }
}

const mapDispatchToProps = {
    hideQuickView
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(HomeSection));
